const Icon = ({ iconclassName }) => <i className={iconclassName}></i>;
export default Icon;
